export default "__VITE_ASSET__64c3f9c6__"